import Api from './Api'

export const ruoliApi = {
  get: () => Api.get('/ruoli'),
  create: dati => Api.post('/ruoli', dati),
  update: (id, dati) => Api.patch(`/ruoli/${id}`, dati),
  remove: id => Api.delete(`/ruoli/${id}`)
}
